import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100;

// Contributions solidaires éditables : libellé, taux (%) ou montant (€), ajout/suppression
export default function ContributionsEditor({ contributions, selected, base, onChange, onToggle, onToggleAll, modele }) {
  const baseVal = parseFloat(base) || 0;
  const maj = (id, patch) => onChange(contributions.map(c => (c.id === id ? { ...c, ...patch } : c)));
  const setMontant = (id, v) => {
    if (baseVal <= 0) return;
    maj(id, { taux: Math.round((parseFloat(v) || 0) / baseVal * 100 * 10000) / 10000 });
  };
  const ajouter = () => {
    const id = `perso-${Date.now()}`;
    onChange([...contributions, { id, nom: 'Nouvelle contribution', taux: 0 }], id);
  };
  const cell = 'px-1.5 py-1 border border-gray-200 rounded text-[11px] bg-white focus:ring-1 focus:ring-orange-400';
  const total = contributions.filter(c => selected.has(c.id)).reduce((s, c) => s + (parseFloat(c.taux) || 0), 0);

  return (
    <div data-testid="recu-contributions-editor">
      <div className="flex items-center justify-between mb-1">
        <label className="block text-xs font-medium text-gray-600">Contributions solidaires</label>
        <button type="button" onClick={onToggleAll} className="text-[10px] font-medium text-orange-600 hover:text-orange-800" data-testid="recu-toggle-all-contribs">
          {contributions.length && contributions.every(c => selected.has(c.id)) ? 'Tout decocher' : 'Tout cocher'}
        </button>
      </div>
      <div className="space-y-1.5 p-2 border border-gray-200 rounded-lg bg-gray-50/50 max-h-64 overflow-y-auto">
        {contributions.map(c => (
          <div key={c.id} className="flex items-center gap-1.5" data-testid={`recu-contrib-${c.id}`}>
            <input type="checkbox" checked={selected.has(c.id)} onChange={() => onToggle(c.id)} className="h-3.5 w-3.5 accent-orange-500" data-testid={`recu-contrib-check-${c.id}`} />
            <input value={c.nom} onChange={e => maj(c.id, { nom: e.target.value })} className={`${cell} flex-1 min-w-0`} title={c.nom} data-testid={`recu-contrib-nom-${c.id}`} />
            <input type="number" step="0.01" min="0" value={c.taux} onChange={e => maj(c.id, { taux: e.target.value })} className={`${cell} w-16 text-right`} title="Taux %" data-testid={`recu-contrib-taux-${c.id}`} />
            <span className="text-[10px] text-gray-400">%</span>
            <input type="number" step="0.01" min="0" value={r2(baseVal * (parseFloat(c.taux) || 0) / 100)} disabled={baseVal <= 0}
              onChange={e => setMontant(c.id, e.target.value)} className={`${cell} w-20 text-right`} title="Montant €" data-testid={`recu-contrib-montant-${c.id}`} />
            <span className="text-[10px] text-gray-400">€</span>
            <button type="button" onClick={() => onChange(contributions.filter(x => x.id !== c.id))} className="text-gray-300 hover:text-red-500" title="Supprimer" data-testid={`recu-contrib-suppr-${c.id}`}>
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
        <button type="button" onClick={ajouter} className="flex items-center gap-1 text-[11px] font-medium text-orange-600 hover:text-orange-800 pt-1" data-testid="recu-contrib-ajouter">
          <Plus className="h-3 w-3" /> Ajouter une contribution
        </button>
      </div>
      <div className="text-[10px] text-gray-400 mt-1 flex justify-between">
        <span>Modèle <strong data-testid="recu-contrib-modele">{modele}</strong> — enregistré pour ce dispositif à la génération.</span>
        <span>Taux total : <span className="font-semibold text-orange-600" data-testid="recu-contrib-taux-total">{total.toFixed(2)}%</span></span>
      </div>
    </div>
  );
}
